import React from "react";
import { Close as DialogPrimitiveClose } from "@radix-ui/react-dialog";
import PropTypes from "prop-types";
import cc from "classcat";
import { twMerge } from "tailwind-merge";
ModalClose.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
};
export default function ModalClose(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DialogPrimitiveClose, {
        asChild: true,
        className: twMerge(cc([
            "absolute right-3 top-3 z-10 self-end px-0 py-0 text-gray-400 outline-none hover:cursor-pointer hover:text-gray-500 focus:text-gray-500",
            className
        ]))
    }, children));
}
